<button
    matButton="filled"
    class="kh-flat-button"
    (click)="click($event)"
    [disabled]="isVisuallyDisabled"
    [disabledInteractive]="isDisabledInteractive"
    [style.width]="computedWidth"
    [style.height]="computedHeight"
>
    @if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
    }
    @if (iconRight) {
        <mat-icon iconPositionEnd>{{ iconRight }}</mat-icon>
    }
    <ng-content></ng-content>
</button>
